import { Injectable } from '@angular/core';

import {httpOptions} from '../../configurations/configuration';
import { HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {


    constructor(private http: HttpClient) { }

    updateSubscription(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateSubscriptionUrl, postObj,httpOptions);
    }
          
    insertSubscription(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertSubscriptionUrl, postObj,httpOptions);
    }    
    
    getSubscription( id: any) : Observable<any> {
        
        if(id){
  
        }
        else {
            id = 1;
        }
  
        return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getSubscriptionUrl+"/" + id);
    }
  
    getAllSubscription(filterObj,start,limit){

        filterObj.languageId = localStorage.getItem('languageId');

        let urlGetAllAsset = environment.apiURL + environment.adminApiUrl + environment.getSubscriptionUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
        return this.http.get<any>(urlGetAllAsset)
    }
  
    deleteSubscription(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteSubscriptionUrl, postObj,httpOptions);
    }

    // Gamification dashboard report
    getGamificationDashboard() : Observable<any> {
        return this.http.get(environment.apiURL + environment.adminApiUrl + environment.gamificationDashboardUrl);
    }

    // Get user actions for gamification dashboard
    getUserActions(userId: any, start: number = 0, limit: number = 10, filters?: {
        startDate?: string;
        endDate?: string;
    }) : Observable<any> {
        let url = environment.apiURL + environment.adminApiUrl + environment.userActionsUrl + '/' + userId + '?start=' + start + '&limit=' + limit;
        
        if (filters) {
            const params = new URLSearchParams();
            
            // Add date filters if provided
            if (filters.startDate) {
                params.append('start_date', filters.startDate);
            }
            if (filters.endDate) {
                params.append('end_date', filters.endDate);
            }
            
            if (params.toString()) {
                url += '&' + params.toString();
            }
        }
        
        return this.http.get(url);
    }

    // Gamification dashboard with filters
    getGamificationDashboardWithFilters(filters?: {
        startDate?: string;
        endDate?: string;
        interval?: 'daily' | 'weekly' | 'monthly';
        platform?: string;
        actionKey?: string;
        userId?: number;
        timezone?: string;
        start?: number;
        limit?: number;
    }) : Observable<any> {
        const baseUrl = environment.apiURL + environment.adminApiUrl + environment.gamificationDashboardUrl;
        
        if (!filters) {
            return this.http.get(baseUrl);
        }

        const params = new URLSearchParams();
        
        // Build filter object for complex filters
        const filterObj: any = {};
        if (filters.startDate) filterObj.start_date = filters.startDate;
        if (filters.endDate) filterObj.end_date = filters.endDate;
        if (filters.actionKey && filters.actionKey !== 'all') filterObj.action_key = filters.actionKey;
        if (filters.userId) filterObj.id = filters.userId;
        
        if (Object.keys(filterObj).length > 0) {
            params.append('filter', JSON.stringify(filterObj));
        }
        
        // Add simple parameters
        const simpleParams = {
            interval: filters.interval,
            platform: filters.platform !== 'all' ? filters.platform : null,
            tz: filters.timezone,
            start: filters.start || 0,
            limit: filters.limit || 100
        };
        
        Object.entries(simpleParams).forEach(([key, value]) => {
            if (value) params.append(key, value.toString());
        });
        
        return this.http.get(`${baseUrl}?${params.toString()}`);
    }
}
